<template>
  <div>
    <v-card class="mb-8">
      <v-card-title>
        Spendiere mir einen <span class="coffee-cup">☕</span>
      </v-card-title>
      <v-card-text>
        <p>
          Im Projekt steckt viel Arbeit und Herzblut. Unterstütze doch meine
          weitere Arbeit daran, indem du mir einen Kaffee spendierst.
        </p>
        <v-row>
          <v-col cols="12" md="12">
            <!-- Slider -->
            <v-slider
              v-model="amount"
              min="1"
              max="5"
              step="1"
              thumb-label="always"
              :thumb-size="getSliderSize(amount)"
              color="brown darken-2"
              hide-messages
            >
              <template v-slot:thumb-label>
                <span :style="getThumbLabelStyle(amount)">☕</span>
              </template>
            </v-slider>
            <div
              v-if="thankyou"
              class="mb-4 pulse"
              style="font-size: xx-large; font-weight: bold; text-align: center; color: green;"
            >
              Vielen lieben Dank
            </div>
            <div
              style="font-size: xx-large; font-weight: bold; text-align: center; color: #0c1424;"
              class="mb-8"
            >
              {{ amount }} x <span class="coffee-cup">☕</span> für {{ money }} €
            </div>
          </v-col>
        </v-row>
        <!-- PayPal Donate Button -->
        <div id="donate-button-container">
          <div id="donate-button"></div>
        </div>
      </v-card-text>
    </v-card>
    <!-- Confetti Animation -->
    <canvas ref="confettiCanvas" class="confetti-canvas"></canvas>
  </div>
</template>

<script>
/* global PayPal */
import confetti from "canvas-confetti";

export default {
  data() {
    return {
      amount: 1,
      thankyou: false,
    };
  },
  computed: {
    money() {
      return this.amount * 5;
    },
  },
  mounted() {
    this.loadPayPalDonationButton();
  },
  methods: {
    getThumbLabelStyle(amount) {
      const baseSize = 16; // Standard-Schriftgröße
      return {
        fontSize: `${baseSize + 4 * amount}px`, // Dynamische Größe basierend auf dem Wert
        lineHeight: "1",
        display: "inline-block",
        textAlign: "center",
      };
    },
    getSliderSize(size) {
      return 32 + 4 * size;
    },
    launchConfetti() {
      confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 },
      });
    },
    loadPayPalDonationButton() {
        // Check if the PayPal SDK script is already loaded
        /*
        if (document.querySelector('script[src="https://www.paypalobjects.com/donate/sdk/donate-sdk.js"]')) {
            console.log("PayPal SDK already loaded.");
            return; // Prevent duplicate loading
        }
        */
      const script = document.createElement("script");
      script.src = "https://www.paypalobjects.com/donate/sdk/donate-sdk.js";
      script.charset = "UTF-8";
      script.onload = () => {
        //if (!document.querySelector("#donate-button > iframe")) {
            PayPal.Donation.Button({
            env: "production",
            hosted_button_id: "BFP4YLBBUKCRW",
            image: {
                src: "https://pics.paypal.com/00/s/Zjk3MmYwN2YtZjUwMi00MzgyLWI4MWItYjVlNzY2NzM3OTQz/file.PNG",
                alt: "Spenden mit dem PayPal-Button",
                title: "PayPal - The safer, easier way to pay online!",
            },
            onComplete: function (/*params*/) {
            this.launchConfetti();
                    this.thankyou=true;
                    setTimeout(()=>{
                        this.thankyou=false;
                    },30000)
                },
            }).render("#donate-button");
        //}
      };
      script.onerror = () =>
        console.error("PayPal Donate SDK konnte nicht geladen werden.");
      document.head.appendChild(script);
    },
    
    /*
    renderPayPalButton() {
  paypal.Buttons({
    fundingSource: paypal.FUNDING.PAYPAL, // Only show PayPal button

    createOrder: (data, actions) => {
      return actions.order.create({
        purchase_units: [
          {
            amount: {
              value: Number(this.money).toFixed(2),
            },
          },
        ],
      });
    },
    onApprove: (data, actions) => {
      return actions.order.capture().then((details) => {
        this.launchConfetti();
        this.thankyou=true;
        setTimeout(()=>{
            this.thankyou=false;
        },30000)
        this.$emit("payment-success", details);
      });
    },
    onError: (err) => {
      console.error("Fehler beim Bezahlvorgang:", err);
      this.$emit("payment-error", err);
    },

    style: {
      layout: 'vertical', // optional: can choose between 'horizontal' and 'vertical' layout
    }
  }).render(this.$refs.paypalButtonContainer);
},
*/
  },
};
</script>

<style scoped>
#donate-button{
    text-align: center;
}
.confetti-canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.coffee-cup {
  font-size: 2rem;
  margin: 0 0.2rem;
  transition: transform 1.3s;
}

.coffee-cup:hover {
  transform: scale(1.3);
}
.pulse {
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
</style>
